import { ApiError } from './api-client'

export function toUserMessage(error: unknown): string {
  if (error instanceof TypeError) {
    return 'Something went wrong. Check your connection and try again.'
  }
  if (error instanceof ApiError && error.status >= 400 && error.status < 500 && error.detail) {
    return error.detail
  }
  return 'Something went wrong. Please try again.'
}
